/**
 * Feedback after a form post (a sent message, a sign-up, a list of errors). The page has just reloaded, so the message
 * may be below the fold, above the form on phones. It is scrolled into view and focused, so keyboard and screen reader
 * users land on it; the message element keeps its own role (status or alert) and tabindex="-1".
 */
class LfFormNote extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => {
      const note = this.firstElementChild;
      if (!(note instanceof HTMLElement)) return;
      note.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      note.focus({ preventScroll: true });
    });
  }
}

if (!customElements.get('lf-form-note')) customElements.define('lf-form-note', LfFormNote);
